import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import debounce from "lodash/debounce";
import { Form, Select, Icon, Spin } from "antd";
import { dadataSearch, dadataSet } from "../../redux/actions/daData";
import { selectDadata } from "../../selectors/daData";
import "../../../../common/css/dadata.css";
const FormItem = Form.Item;
const Option = Select.Option;

const fetchingIcon = <Icon type="loading" spin />;

class DadataSearch extends Component {
  constructor(props) {
    super(props);

    this.fetchSearchResults = debounce(this.fetchSearchResults, 800);

    this.state = {
      isActive: true,
      value: "",
      suggestions: [],
      fetching: false,
      searchStatus: "",
      searchError: ""
    };
  }

  fetchSearchResults = value => {
    const { dadataSearch } = this.props;
    if (value.length > 3) {
      this.setState({
        fetching: true
      });
      dadataSearch(value);
    } else {
      this.setState({
        fetching: false
      });
    }
  };
  onAutoSearchChange = value => {
    let { result, handleChange } = this.props;
    if (value) {
      const { dadataSet } = this.props;
      let name = value.split(",")[0].trim();
      let inn = value.split(",")[1].trim();
      let selectedVal = result.filter(
        option => option.inn === inn && option.name === name
      );
      this.setState({
        value: name
      });
      dadataSet(selectedVal[0]);
      if (handleChange) handleChange(selectedVal[0]);
    }
  };
  render() {
    const { result, form } = this.props; // validStatus, error,
    const { fetching, value } = this.state;
    return (
      <Fragment>
        {this.props.label ? this.props.label : null}
        <FormItem
          label={!this.props.label ? "Организация:" : null}
          className="organization"
        >
          {form.getFieldDecorator("dadataSearch", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(
            <Select
              id="dadataSearch"
              showSearch
              showArrow={false}
              allowClear
              notFoundContent={
                fetching ? <Spin indicator={fetchingIcon} size="small" /> : null
              }
              filterOption={false}
              suggestions={result}
              getPopupContainer={trigger => trigger.parentNode}
              placeholder="Укажите наименование или ИНН"
              onSearch={this.fetchSearchResults}
              onChange={this.onAutoSearchChange}
              optionLabelProp="data-orgname"
              className={`${
                value ? "notDadataPlaceholder dadataSearch" : "dadataSearch"
              } `}
              style={this.props.style ? this.props.style : null}
            >
              {result &&
                result.map(s => (
                  <Option key={s.key} data-orgname={`${s.name}`}>
                    <span
                      style={{
                        display: "block",
                        fontSize: "14px",
                        textTransform: "uppercase",
                        color: "#323232",
                        letterSpacing: "-0.7px"
                      }}
                    >
                      {s.name}
                    </span>
                    <span
                      style={{
                        display: "block",
                        color: "#9b9b9b",
                        fontSize: "14px",
                        letterSpacing: "-0.7px"
                      }}
                    >
                      <span style={{ color: "#00a8ff" }}>
                        {s.inn.slice(0, 4)}
                      </span>
                      {s.inn.slice(4)}, {s.address}
                    </span>
                  </Option>
                ))}
            </Select>
          )}
        </FormItem>
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    result: selectDadata(state),
    status: state.Authorization.dadata.status
  }),
  { dadataSearch, dadataSet }
)(DadataSearch);
